import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import { getPayload } from "./http";
/**
* EIP-1193 provider, which can be used with the `window.ethereum` object.
*/

var provider = {
  isProvider: function isProvider(a) {
    return void 0 !== (null === a || void 0 === a ? void 0 : a.request);
  },
  send: function () {
    var _send = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(a, b, c) {
      var d;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              d = getPayload(b, c);
              return _context.abrupt("return", a.request(d));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function send(_x, _x2, _x3) {
      return _send.apply(this, arguments);
    }

    return send;
  }()
};
export default provider;